import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useLayoutEffect } from 'react';
import {
  accountSelector,
  errorAccountLoadingSelector,
  lastAccessedSiteIdSelector,
  lastAccessedWidgetSelector,
  loadingAccountSelector,
} from 'src/redesign/features/Account/store/selectors';
import { fetchSettingsApi, getFonts } from 'src/features/settings-slice';
import { getAccountInfo } from 'src/redesign/features/Account/store/actions';
import { useHistory } from 'react-router-dom';
import { fetchEvents } from 'src/redesign/features/Events/store/actions';
import { fetchAllUserSites } from 'src/redesign/features/Sites/actions';
import { fetchSiteDataById } from 'src/redesign/features/SelectedSite/store/actions';
import { fetchWidgetData } from 'src/redesign/features/Widgets/actions';
import { isPublicRoute } from 'src/app';

export function useFetchAllData() {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const account = useAppSelector(accountSelector);
  const loading = useAppSelector(loadingAccountSelector);
  const error = useAppSelector(errorAccountLoadingSelector);
  const lastSiteAccessedId = useAppSelector(lastAccessedSiteIdSelector);
  const lastWidgetAccessedId = useAppSelector(lastAccessedWidgetSelector);

  useLayoutEffect(() => {
    if (isPublicRoute()) {
      return;
    }

    if (error) {
      history.push('/auth/login');
      return;
    }

    // No account and not loading -> fetch account info
    if (!account) {
      dispatch(getAccountInfo());
      return;
    }

    // If account exists and loading finished
    if (account && !loading) {
      dispatch(fetchSettingsApi());

      dispatch(fetchAllUserSites());
      dispatch(getFonts());

      // Always fetch site and widget, even if lastSiteAccessedId / lastWidgetAccessedId are undefined
      dispatch(fetchSiteDataById(lastSiteAccessedId));
      dispatch(fetchWidgetData({ siteId: lastSiteAccessedId, widgetId: lastWidgetAccessedId }));

      // Fetch events if site ID exists
      if (lastSiteAccessedId) {
        dispatch(fetchEvents());
      }
    }
  }, [account, loading, error, dispatch, history, lastSiteAccessedId, lastWidgetAccessedId]);

  return null;
}
